import { render, staticRenderFns } from "./SuperAdminGateway.vue?vue&type=template&id=49a2c871"
import script from "./SuperAdminGateway.vue?vue&type=script&lang=js"
export * from "./SuperAdminGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports